import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class ActionCollections extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'ActionCollections'
  // Define default properties here
  static instanceDefaults () {
    return {
      title: '',
      description: '',
      visibility: 'private',
      isEnabled: false,
      userId: null,
      mediaId: null,
      media: null,
      standardActionsCount: '0',
    }
  }
}
const servicePath = 'action-collections'
const servicePlugin = makeServicePlugin({
  Model: ActionCollections,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
